// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__gH7ss","link":"Footer_link__ihLiu"};